// Shell de escritorio — en pantallas grandes (lg, ≥1024px) la app deja de verse
// como un celular estirado: las pestañas de la nav v2 viven como texto dentro del
// header sticky, el panel de Benito se acopla al borde derecho (convive con el
// contenido en vez de taparlo) y MiPAE en turno muestra el rail de camas junto a la
// ficha. Todo se expresa SOLO con clases lg:/xl:, así que bajo 1024px el celular
// queda pixel-idéntico.
//
// Kill-switch ON por defecto (norma del repo: !== 'false', nunca === 'true').
// Con REACT_APP_SHELL_ESCRITORIO_ENABLED='false' el escritorio vuelve a como
// estaba: tab bar abajo, Benito modal, ficha en una sola columna.
//
// El shell se DEFINE sobre la nav agente-céntrica (sus 5 pestañas alimentan la
// nav del header y el botón de Benito, y su modo controlado del panel es el que
// permite acoplarlo). Hasta el 2026-09-14 llevaba un AND con REACT_APP_NAV_V2;
// ese flag se retiró junto con el Home viejo (la nav agente-céntrica es la
// única), así que este es el único interruptor del escritorio.
export const SHELL_ESCRITORIO_ENABLED =
  process.env.REACT_APP_SHELL_ESCRITORIO_ENABLED !== 'false';
